import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'reactstrap/lib/Form';
import { FormRequestCall as FormRequestCallCore, FormattedTag } from 'core/components';
import { withCoreComponent, withModalActions } from 'core/hocs';
import { getEnv } from 'core/helpers';
import { LOCAL } from 'core/constants';
import { ButtonWithLoader } from 'components/button-with-loader/button-with-loader';
import { FormElement } from 'components/form-element/form-element';

import './form-request-call.scss';
import { IconMail } from 'components/icons/icon-mail/icon-mail';
import { IconCalendar } from 'components/icons/icon-calendar/icon-calendar';
import { IconClock } from 'components/icons/icon-clock/icon-clock';
import { IconPhone } from 'components/icons/icon-phone/icon-phone';
import colors from '../../../customizations/js/color-variables';

class FormRequestCallUI extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    fields: PropTypes.shape().isRequired,
    isInProgress: PropTypes.bool.isRequired,
    isSuccess: PropTypes.bool,
    executeRecaptcha: PropTypes.func.isRequired,
    boxDateFormat: PropTypes.string,
  };

  static defaultProps = {
    isSuccess: false,
    boxDateFormat: '',
  };

  componentDidUpdate = ({ isSuccess: isSuccessPrev }) => {
    const { isSuccess } = this.props;

    document.documentElement.style.setProperty('--viewport-width', `${window.innerWidth}px`);

    if (isSuccess && !isSuccessPrev) {
      // close
    }
  };

  onSubmit = (e) => {
    const {
      onSubmit,
      executeRecaptcha,
    } = this.props;

    e.preventDefault();

    const isLocal = getEnv('PROJECT_ENV') === LOCAL;

    onSubmit(e, executeRecaptcha, isLocal);
  };

  render() {
    const { fields, isInProgress, boxDateFormat } = this.props;

    return (
      <div className="p-3">
        <Form onSubmit={this.onSubmit} className="request-call-form">
          <div className="d-flex flex-column align-items-center">
            <FormattedTag tag="h3" id="form.request-call.title" className="h3 text-white mb-2" />
            <FormattedTag tag="h5" id="form.request-call.description" className="h5 text-gray-30 mb-2 font-weight-normal text-center" />
          </div>

          <FormElement
            coreProps={{ item: fields.email }}
            formGroupClassName="w-100 my-1"
            // eslint-disable-next-line react/jsx-no-bind
            icon={() => <IconMail color={colors.white} />}
          />

          <FormElement
            coreProps={{ item: fields.mobilePhone }}
            formGroupClassName="w-100 my-1"
            // eslint-disable-next-line react/jsx-no-bind
            icon={() => <IconPhone color={colors.white} />}
          />

          <FormElement
            coreProps={{ item: fields.date }}
            formGroupClassName="w-100 my-1"
            boxDateFormat={boxDateFormat}
            preventPastDates
            validateToday
            todayValidTill={{ h: 23, m: 0 }} // 24h format
            isRawDates
            // eslint-disable-next-line react/jsx-no-bind
            icon={() => <IconCalendar color={colors.white} />}
          />

          <FormElement
            coreProps={{ item: fields.hourRange }}
            formGroupClassName="w-100 my-1"
            icon={IconClock}
          />

          <FormElement
            coreProps={{ item: fields.note }}
            formGroupClassName="my-1"
          />

          <div>
            <FormattedTag
              tag={ButtonWithLoader}
              contentClassName="text-base"
              id="form-request-call.submit-btn"
              isLoading={isInProgress}
              color="primary"
              size="lg"
              className="submit-btn mt-0_5 text-switch-white font-weight-bold letter-spacing-normal w-100"
              type="submit"
            />
          </div>
        </Form>
      </div>
    );
  }
}

export const FormRequestCall = withCoreComponent(
  FormRequestCallCore,
  withModalActions(FormRequestCallUI)
);
